export default __webpack_public_path__ + "static/media/Mirror Image 2018 -- Pastel, Acrylic, and Watercolor on Paper with Collage -- 24in x 19in.da7563dc.png";